<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('preorder_overview.page_title') }}</slot>
            <slot slot="description">
                <p>{{ $t('preorder_overview.description') }}</p>
            </slot>
        </page-header>

        <!-- preorders -->
        <v-overview-list
                data-table="PreOrders"
                data-filter="PreOrdersFilters"
                data-pagination="PreOrdersPagination"
                btnViewPath="SalesmanPreOrdersEdit"
                filter-theme="white"
                :filters="PreOrders.filters"
                :table-columns="PreOrders.columns"
                :btnCopy="false"
                :page-size="12"
                :title="$t('preorder_overview.running_negotiations')"
                prefix="lop">

            <template slot="placeholderButtons">
                <router-link class="c-button c-button--icon c-button--alpha u-flex--push-left" to="/salesman/pre-orders/create">
                    <svgicon name="added"></svgicon>
                    <span>{{ $t('preorder_overview.assign_new') }}</span>
                </router-link>
            </template>
        </v-overview-list>

        <hr class="c-seperator c-seperator--large">

        <!-- forecasted -->
        <v-overview-list
                data-table="PreOrdersForecasted"
                data-pagination="PreOrdersForecastedPagination"
                btnAssignPath="SalesmanPreOrdersCreate"
                filter-theme="white"
                :table-columns="PreOrdersForecasted.columns"
                :btnCopy="false"
                :page-size="12"
                :title="$t('preorder_overview.assignable_preorders')"
                prefix="ttw">
        </v-overview-list>

        <hr class="c-seperator c-seperator--large">

        <!-- sheets -->
        <v-overview-list
                data-table="PreOrderSheets"
                data-filter="PreOrderSheetsFilters"
                data-pagination="PreOrderSheetsPagination"
                btnAssignPath="SalesmanPreOrdersCreate"
                filter-theme="white"
                :filters="PreOrderSheets.filters"
                :table-columns="PreOrderSheets.columns"
                :page-size="12"
                :title="$t('preorder_overview.available_preorders')"
                prefix="pos">

            <template slot="placeholderButtons">
                <router-link class="c-button c-button--icon c-button--alpha u-flex--push-left" to="/salesman/pre-orders/create">
                    <svgicon name="added"></svgicon>
                    <span>{{ $t('preorder_overview.assign_new') }}</span>
                </router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VFilters from '@/components/form/filters/Filters'
    import VPagination from '@/components/Pagination'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VFilters,
            VPagination,
            VSelect,
            VOverviewList
        },
        computed: {
            PreOrders() {
                return {
                    filters: [
                        { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'brand', width:150 },
                        { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'collection', width:150 },
                        { name: this.$t('preorder_overview.filters.customer'), value: 'Customers', single: 'customer', width:130 },
                        { name: this.$t('preorder_overview.filters.country'), value: 'Countries', single: 'country', width:130 },
                        { name: this.$t('preorder_overview.filters.states'), value: 'States', single: 'state', width:130 },
                        { name: this.$t('preorder_overview.filters.has_new_messages'), value: 'HasNewMessages', single: 'newMessages', allowMultiple: false, width:200 },
                        { name: this.$t('preorder_overview.filters.my_customers'), value: 'MyCustomersOnly', single: 'myCustomers', allowMultiple: false, width:170 },                        
                        { name: this.$t('preorder_overview.filters.my_sheets'), value: 'MySheetsOnly', single: 'mySheets', allowMultiple: false, width:200 }                        
                    ],
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        // { value: 'ProcessDate', name: 'Process Datum', type: 'Date' },
                        { value: 'CustomerAltKey', name: this.$t('preorder_overview.columns.customer_key') },
                        { value: 'Customer', name: this.$t('preorder_overview.columns.customer') },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref') },
                        { value: 'LastUpdate', name: this.$t('preorder_overview.columns.last_update'), type:'Date'},
                        { value: 'HasUnReadMessages', name: this.$t('preorder_overview.columns.messages') , type: 'Message'},
                        { value: 'State', name: this.$t('preorder_overview.columns.state') },
                        { value: 'Deadline', name: this.$t('preorder_overview.columns.deadline'), type: 'Date' }
                    ]
                };
            },
            PreOrdersForecasted() {
                return {
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        { value: 'CustomerAltKey', name: this.$t('preorder_overview.columns.customer_key') },
                        { value: 'Customer', name: this.$t('preorder_overview.columns.customer') },
                        { value: 'Country', name: this.$t('preorder_overview.columns.country') },
                        { value: 'StartDate', name: this.$t('preorder_overview.columns.startdate'), type: 'Date'},
                        { value: 'Deadline', name: this.$t('preorder_overview.columns.deadline'), type: 'Date' }
                    ]};
            },
            PreOrderSheets() {
                return {
                    filters: [
                        { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'brand', width:150 },
                        { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'collection', width:150 },
                        { name: this.$t('preorder_overview.filters.states'), value: 'States', single: 'state', width:150 }
                    ],
                    columns: [
                        { value: 'Name', name: this.$t('preorder_overview.columns.name') },
                        { value: 'StartDate', name: this.$t('preorder_overview.columns.startdate'), type: 'Date' },
                        { value: 'Deadline', name: this.$t('preorder_overview.columns.deadline'), type: 'Date' },
                        { value: 'LastUpdate', name: 'Laatste update', type:'Date' },
                        { value: 'ProductCount', name: this.$t('preorder_overview.columns.product_count') },
                        { value: 'AssignedCustomers', name: this.$t('preorder_overview.columns.assigned_customers') },
                    ]
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/salesman/preOrders/index.vue